module.exports = __webpack_public_path__ + "img/p2_menghuanpaopao.353a89b0.jpg";